import React from 'react';

function TabsNavigation({ activeTab, setActiveTab }) {
    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    return (
        <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
                <button
                    className={`nav-link ${activeTab === 'root-pools' ? 'active' : ''}`}
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-home"
                    type="button"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected={activeTab === 'root-pools'}
                    onClick={() => handleTabClick('root-pools')}
                >
                    Root Pools
                </button>
            </li>
            <li className="nav-item" role="presentation">
                <button
                    className={`nav-link ${activeTab === 'child-pools' ? 'active' : ''}`}
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-profile"
                    type="button"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected={activeTab === 'child-pools'}
                    onClick={() => handleTabClick('child-pools')}
                >
                    Child Pools
                </button>
            </li>
            <li className="nav-item" role="presentation">
                <button
                    className={`nav-link ${activeTab === 'my-stakes' ? 'active' : ''}`}
                    id="pills-contact-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-contact"
                    type="button"
                    role="tab"
                    aria-controls="pills-contact"
                    aria-selected={activeTab === 'my-stakes'}
                    onClick={() => handleTabClick('my-stakes')}
                >
                    My Stakings
                </button>
            </li>
        </ul>
    );
}

export default TabsNavigation;